export class Supergroup {
  constructor(id, name, tag, priority, manual_active, translation_id, translation, updatedAt, image) {
    this.id = id;
    this.name = name;
    this.tag = tag;
    this.priority = priority;
    this.manual_active = manual_active;
    this.translation_id = translation_id;
    this.translation = translation;
    this.updated_at = updatedAt;
    this.image = image;
  }

  get key() {
    return this.id + "-" + this.updated_at;
  }
}

export const CreateSupergroup = (json) =>
  new Supergroup(
    json.id,
    json.name,
    json.tag,
    json.priority,
    json.manual_active,
    json.translation_id,
    json.translation,
    json.updated_at,
    json.image
  );
